import React from 'react';
import Wrapper from './components/Wrapper';

const App = () => <Wrapper/>

export default App;
